import styles from "./AchievementCard.module.scss";
import arrowIcon from "../../icons/arrow.png";
import { FC, useEffect, useState } from "react";
import { AchievementItem } from "./AchievementItem";

export type TItemType = 'completed' | 'progress' | 'close';

interface IAchievementCardProps {
    title: string;
    description: string;
    level: number;
    value: number;
    tips: string[];
    limits: number[];
}

export const AchievementCard: FC<IAchievementCardProps> = ({ title, description, level, value, tips, limits }) => {
    const LEVELS_COUNT = 5;
    const [progress, setProgress] = useState(0);
    const [items, setItems] = useState<TItemType[]>([]);

    useEffect(() => {
        const completedProgress = level / LEVELS_COUNT;
        const targetValue = limits?.[level] ?? 0;
        const prevLimitValue = limits?.[level - 1] ?? 0;

        const getCurrentProgress = () => {
            const deltaTarget = prevLimitValue !== targetValue ? targetValue - prevLimitValue : targetValue;
            return (value - prevLimitValue) / deltaTarget / LEVELS_COUNT;
        };

        const currentProgress = getCurrentProgress();
        setProgress(Math.floor((completedProgress + currentProgress) * 100));
    }, [level, limits, value]);
    
    useEffect(() => {
        const newItems: TItemType[] = [];
        for (let levelIndex = 0; levelIndex < LEVELS_COUNT; ++levelIndex) {
            if (levelIndex < level)
                newItems.push('completed');
            else if (levelIndex === level)
                newItems.push('progress');
            else
                newItems.push('close');
        }
        setItems(newItems);
    }, [level]);
    
    return (
        <div className={styles.collectionCard}>
            <div className={styles.header}>
                <h3 className={styles.title}>{title}</h3>

                <div className={styles.description}>{description}</div>
            </div>

            <div className={styles.progressSection}>
                <div className={styles.progressHeader}>
                    <span className={styles.progressLabel}>
                        Выполнено
                        <img src={arrowIcon} alt="Arrow Icon" className={styles.arrowIcon} />
                    </span>
                
                    <span className={styles.progressValue}>{progress}%</span>
                </div>

                <div className={styles.progressBar}>
                    <div
                        className={styles.progressFill}
                        style={{ width: `${progress}%` }}
                    />
                </div>
            </div>

            <div className={styles.items}>
                { items.map((type, index) =>
                    <AchievementItem
                        type={ type }
                        index={ index }
                        currentValue={ value }
                        targetValue={ limits?.[index] }
                        tips={ tips[index] }
                    />) }
            </div>
        </div>
    )
}